const channelName = key =>
  I18n.t(key, {
    scope: 'channels',
  });

export default channelName;
